export default __webpack_public_path__ + "static/media/popup card.ec4df470.svg";